import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Preloads only the lazy routes marked `data: { preload: true }`, in the
 * background once the first page is up. The booking page uses it so "Book
 * Now" / "Book Free Appointment" switch pages instantly instead of waiting for
 * its code on the click. Everything else (the signed-in dashboard in
 * particular) still downloads only when it is actually visited.
 */
@Injectable({ providedIn: 'root' })
export class FlaggedPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    return route.data?.['preload'] === true ? load() : of(null);
  }
}
